
const displayErrorText = {
    REQUIRED_FIELD: 'Campo requerido',
    VALID_EMAIL: 'Ingrese un correo electrónico válido',
    VALID_PHONE: 'Ingrese un número de teléfono válido',
    PASSWORD_NOT_MATCH: 'Las contraseñas no coinciden',
    USED_EMAIL: 'Correo electrónico en uso'
}

export type ErrorName = keyof typeof displayErrorText

export default function errorText(error:ErrorName|string) {
    return displayErrorText[error] || error
}